import fetch from "@/fetch";

// 获取CSH列表数据
export const getCshlist = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/todaysnapshot/select_csh",
    data: params
  });
};

// 获取Header部数据（客户增加数量/用户数量/下单用户数量/E-chart图表数据）
export const getUserData = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/userCenterDetail/getCenterUserCountInfo",
    data: params
  });
};

//订单查询结果
export const getUserList = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/userCenterDetail/getUserList",
    data: params
  });
};
